import { createContext, useContext } from "react";
import { FeatureFlag } from "./activeFlags";

// The default value is the offline local checker, which answers from the registry synchronously —
// nothing to wait for, so it is ready from the first render.
export const FeatureFlagContext = createContext({
  isFeatureActive: FeatureFlag.isFeatureActive,
  isReady: true,
});

export const useFeatureFlags = () =>
  useContext(FeatureFlagContext).isFeatureActive;

export const useFeatureFlag = (flagName) => useFeatureFlags()(flagName);

// False while a real provider is still initialising, i.e. while every gate reads as its registry
// default. Screens whose OFF branch is merely a different behaviour can ignore it; a screen that
// WRITES what the flag selects has to wait, because the default is not a safe state there.
export const useFeatureFlagsReady = () => useContext(FeatureFlagContext).isReady;
